import axios from "axios";
import { api } from "./api_route";

export const createAlert = async (formData) => {
  const response = await axios.post(`${api}/alerts/create`, formData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getAlerts = async () => {
  const response = await axios.get(`${api}/alerts`);
  return response.data;
};

export const getAlertById = async (alertID) => {
  const response = await axios.get(`${api}/alerts/${alertID}`);
  return response.data;
};

export const updateAlert = async (alertID, formData) => {
  const response = await axios.put(`${api}/alerts/update/${alertID}`, formData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const deleteAlert = async (alertID) => {
  const response = await axios.delete(`${api}/alerts/delete/${alertID}`);
  return response.data;
};
